import { Link } from "react-router-dom";
import { PageShell } from "../components/Layout";

export default function NotFound() {
  return (
    <PageShell>
      <div className="min-h-[70vh] flex flex-col items-center justify-center gap-6 tactical-grid" data-testid="not-found-page">
        <p className="font-display font-black uppercase text-[22vw] sm:text-9xl leading-none text-outline select-none">404</p>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-gray-400">Perimeter breached — page not found</p>
        <Link
          to="/"
          data-testid="not-found-home-btn"
          className="font-display font-bold uppercase tracking-widest text-sm bg-amber text-ink px-7 py-4 hover:bg-white transition-colors duration-300"
        >
          Return to base
        </Link>
      </div>
    </PageShell>
  );
}
